import React, { Component } from 'react';
// import {storeProducts,detailProduct} from './data'

const CourseContext = React.createContext()
class CourseProvider extends Component {
    state={
        
    }

    render() {
        return (
            <CourseContext.Provider value={{}}>
                {this.props.children}
            </CourseContext.Provider>
        );
    }
}


const ProductConsumer = CourseContext.Consumer

export {CourseProvider,ProductConsumer };